module.exports = __webpack_public_path__ + "static/img/2.ee589be.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/detail/common/questionnaire/2.png
// module id = GdPE
// module chunks = 1